// extracted by mini-css-extract-plugin
export var closed = "_hc-1";
export var resizer = "_hc-0";